/* =========================================================================
   Big Springs Water — native coverage map (MapLibre GL JS, no token)
   Reads points from window.BSW_COVERAGE (assets/bsw-coverage-data.js).
   Zone styling is defined below — edit ZONES to rename/recolour partners.
   ========================================================================= */
(function () {
  'use strict';

  // zone key (from the data) -> display config. Same colours as the old map.
  var ZONES = {
    Big_Springs_Water:      { label: 'Direct delivery',          color: '#2E5597', tier: 'direct' },
    Kiewa_Valley_Water_New: { label: 'Kiewa Valley Spring Water', color: '#F745AA', tier: 'partner', partner: 'Kiewa Valley Spring Water' },
    Greater_Melbourne_V2:   { label: 'Kiewa Valley Spring Water', color: '#F745AA', tier: 'partner', partner: 'Kiewa Valley Spring Water' },
    NovoH20:                { label: 'NovoH2O',                   color: '#24C8F9', tier: 'partner', partner: 'NovoH2O' },
    Summer_Springs_fo_BS:   { label: 'Summer Springs',           color: '#F7E545', tier: 'partner', partner: 'Summer Springs' },
    Southern_Highlands:     { label: 'Spring Alive',             color: '#54BB74', tier: 'partner', partner: 'Spring Alive' },
    Chill_Freeze:           { label: 'Chill Freeze',             color: '#8042B7', tier: 'partner', partner: 'Chill Freeze' }
  };
  // legend order (by zone key). Duplicate labels (Kiewa/Melbourne) are merged.
  var ORDER = ['Big_Springs_Water','Kiewa_Valley_Water_New','NovoH20','Southern_Highlands','Chill_Freeze','Summer_Springs_fo_BS'];

  function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];}); }

  function buildLegend(el, zonesPresent) {
    if (!el) return;
    var seen = {}, html = '';
    ORDER.forEach(function (key) {
      if (!zonesPresent[key]) return;
      var z = ZONES[key];
      if (seen[z.label]) return;
      seen[z.label] = 1;
      html += '<span class="bsw-legend__item"><i class="bsw-swatch" style="background:' + z.color + '"></i>' + esc(z.label) + '</span>';
    });
    el.innerHTML = html;
  }

  function colorMatch() {
    var expr = ['match', ['get', 'zone']];
    Object.keys(ZONES).forEach(function (k) { expr.push(k, ZONES[k].color); });
    expr.push('#888888'); // fallback
    return expr;
  }

  function initOne(root) {
    var el = root.querySelector('[data-bsw-map-canvas]');
    if (!el || el.getAttribute('data-bound')) return;

    if (typeof maplibregl === 'undefined' || !window.BSW_COVERAGE) {
      // graceful fallback — leave any server-rendered fallback content visible
      el.classList.add('bsw-map-live--failed');
      return;
    }
    el.setAttribute('data-bound', '1');

    var data = window.BSW_COVERAGE;
    var frame = root; // initAll passes the [data-bsw-map] element itself
    var tiles = (frame.getAttribute('data-tiles') || 'https://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png').split('||');
    var attribution = frame.getAttribute('data-attribution') || '© OpenStreetMap contributors © CARTO';
    var interactive = frame.getAttribute('data-interactive') !== 'false';

    var map = new maplibregl.Map({
      container: el,
      style: {
        version: 8,
        sources: { basemap: { type: 'raster', tiles: tiles, tileSize: 256, attribution: attribution } },
        layers: [{ id: 'basemap', type: 'raster', source: 'basemap' }]
      },
      center: [Number(frame.getAttribute('data-lng')) || 147.5, Number(frame.getAttribute('data-lat')) || -35.2],
      zoom: Number(frame.getAttribute('data-zoom')) || 5.2,
      attributionControl: true,
      scrollZoom: interactive,
      cooperativeGestures: !interactive
    });

    map.addControl(new maplibregl.NavigationControl({ showCompass: false }), 'top-right');

    map.on('load', function () {
      map.addSource('coverage', { type: 'geojson', data: data });
      map.addLayer({
        id: 'coverage-pts',
        type: 'circle',
        source: 'coverage',
        paint: {
          'circle-color': colorMatch(),
          'circle-radius': ['interpolate', ['linear'], ['zoom'], 4, 3.3, 7, 6, 11, 9.75, 14, 13.5],
          'circle-opacity': 0.85,
          'circle-stroke-width': 1,
          'circle-stroke-color': '#ffffff',
          'circle-stroke-opacity': 0.4
        }
      });

      // fit to data
      try {
        var b = new maplibregl.LngLatBounds();
        data.features.forEach(function (f) { b.extend(f.geometry.coordinates); });
        map.fitBounds(b, { padding: 40, maxZoom: 9, duration: 0 });
      } catch (e) {}

      // popup
      var popup = new maplibregl.Popup({ closeButton: false, closeOnClick: true, className: 'bsw-map-popup', maxWidth: '240px' });
      map.on('click', 'coverage-pts', function (e) {
        var p = e.features[0].properties, z = ZONES[p.zone] || {};
        var html = '';
        if (p.name) html += '<strong>' + esc(p.name) + '</strong><br>';
        html += (z.tier === 'direct') ? 'Direct delivery' : ('Delivered by ' + esc(z.partner || z.label || 'a local partner'));
        popup.setLngLat(e.lngLat).setHTML('<div class="bsw-map-popup__body">' + html + '</div>').addTo(map);
      });
      map.on('mouseenter', 'coverage-pts', function () { map.getCanvas().style.cursor = 'pointer'; });
      map.on('mouseleave', 'coverage-pts', function () { map.getCanvas().style.cursor = ''; });
    });

    // legend
    var present = {};
    data.features.forEach(function (f) { present[f.properties.zone] = 1; });
    buildLegend(root.querySelector('[data-bsw-map-legend]'), present);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bsw-map]').forEach(initOne);
  }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
